import React from 'react'
import { Loader } from '@web/walter-ui-kit'

import styles from './style.module.css'

function FilterPreloader() {
    return (
        <div className={styles.filters}>
            <div className={styles.search}>
                <Loader width={280} height={36} />
            </div>
            <div className={styles.filter}>
                <Loader width={90} height={36} />
            </div>
            <div className={styles.filter}>
                <Loader width={90} height={36} />
            </div>
            <div className={styles.filter}>
                <Loader width={90} height={36} />
            </div>
        </div>
    )
}

export default FilterPreloader
